import { useCallback } from 'react';

import useThrowAsyncError from '../../../../hooks/useThrowAsyncError';
import { MiniSiteMedialink, getUrlForMiniSite } from '../../_api/MedialinksApi';
import { Node } from '../../_api/TableOfContentsApi';
import WebLinkTargets from '../../../../constants/WeblinkTargets';
import WeblinkModal from '../../_modals/WeblinkModal';

export default function useMiniSiteMedialink() {
  const handleError = useThrowAsyncError();

  const openMiniSiteMedialink = useCallback(
    async (medialink: MiniSiteMedialink, node: Node, moduleId: string) => {
      if (medialink.miniSite.target === WebLinkTargets.NEW_WINDOW) return; //handled by anchor tag

      try {
        const { url } = await getUrlForMiniSite(moduleId, medialink.id);

        switch (medialink.miniSite.target) {
          case WebLinkTargets.MODAL:
            return (
              <WeblinkModal
                id="weblink-modal"
                url={url}
                node={node}
                medialink={medialink}
                weblinkInfo={medialink.miniSite}
              />
            );

          case WebLinkTargets.SAME_WINDOW:
            window.location.assign(url);
            break;
        }
      } catch (err) {
        handleError(err);
      }
    },
    [handleError],
  );

  return { openMiniSiteMedialink };
}
